import React, { Component } from 'react';
import { connect } from 'react-redux';
import { jsx, css } from '@emotion/core';
import { FaSpinner } from 'react-icons/fa';

import { primary_s5_l90 } from '../../../shared/lib/colors';

import Link from '../../../shared/Link/Link';
import Button from '../../../shared/Button/Button';
import CheckboxContainer from '../../../shared/FormFields/CheckboxContainer';

import { saveNewsletter } from '../../../../redux/modules/newsletter';

import './Newsletter.scss';
import IubendaCookieSolution from '../../../../utils/iubenda';

class Newsletter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      privacy: false,
    };
  }

  handleChangeEmail = event => {
    this.setState({
      email: event.target.value,
    });
  };

  handleChangePrivacy = event => {
    this.setState({
      privacy: event.target.checked,
    });
  };

  saveNewsletter = event => {
    const { hasIubendaCookieSolution, iubendaApiKey } = this.props;
    if (hasIubendaCookieSolution) {
      const iubenda = new IubendaCookieSolution(
        hasIubendaCookieSolution,
        iubendaApiKey
      );
      iubenda.saveConsentNewsletter(this.state.email);
    }

    event.preventDefault();
    this.props.saveNewsletter(this.state.email);
  };

  render() {
    const {
      loading,
      iscritto,
      error,
      primaryColor,
      newsletterTitle,
      isFullWidth,
      uiVariantBlogNewsletter,
      uiVariantInputText,
    } = this.props;
    const { email } = this.state;

    const newsLetterStyle = css`
      &.variant-1 {
        border: 1px solid ${primaryColor};
        border-radius: 12px;

        h3 {
          color: ${primaryColor};
        }

        form {
          .subtitle {
            font-size: 17px;
          }

          .email-input .btn {
            top: 0;
            right: 0;
            height: 45px;
            font-size: 10px;
            line-height: 1.6;
          }
        }
      }

      &.variant-2 {
        border: 1px solid ${primary_s5_l90(primaryColor)};
        background-color: #fff;

        h3 {
          color: ${primaryColor};
        }

        form {
          .subtitle {
            font-size: 17px;
          }

          .email-input .btn {
            top: 0;
            right: 0;
            height: 45px;
            font-size: 10px;
            line-height: 1.6;
          }
        }

        form input,
        .checkbox label::before {
          border: 1px solid ${primary_s5_l90(primaryColor)}!important;
        }
      }

      &.variant-3 {
        color: #fff;
        background-color: ${primaryColor};
        border: 1px solid #fff;

        form {
          .subtitle {
            font-size: 15px;
            text-transform: uppercase;
          }

          .email-input .btn {
            top: 1px;
            right: 1px;
            height: 43px;
            font-size: 12px;
            line-height: 1.4;
            border: none;
            border-radius: 8px 30px 30px 8px;
          }

          a {
            color: #fff;
          }
        }
      }

      &.boxed {
        margin-top: 40px;

        @media (min-width: 992px) {
          margin-top: 65px;
          height: 290px;
        }

        form {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;
        }
      }

      &.full-width {
        margin-top: 0;

        @media (min-width: 992px) {
          margin-top: 0;
          min-height: auto;
        }

        h3 {
          text-align: center;
        }

        form {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;

          @media (min-width: 992px) {
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
          }

          .subtitle,
          .privacy {
            flex: 1;
          }
          .email-input {
            flex: 2;
          }

          .subtitle,
          .email-input input,
          .checkbox {
            @media (min-width: 992px) {
              margin: 0;
            }
          }

          .email-input {
            @media (min-width: 992px) {
              margin: 0 50px 0 40px;
            }
          }
        }
      }

      form input {
        border-radius: ${uiVariantInputText === '1'
          ? '12px'
          : uiVariantInputText === '3'
          ? '30px'
          : 0};

        &:focus {
          border-color: ${primaryColor};
        }
      }
    `;

    return (
      <div
        className={`newsletter ${
          isFullWidth ? 'full-width' : 'boxed'
        } variant-${uiVariantBlogNewsletter}`}
        css={newsLetterStyle}
      >
        <h3>Newsletter</h3>
        <form id="form_newsletter" onSubmit={this.saveNewsletter}>
          <div className="subtitle">
            {newsletterTitle ||
              'Resta aggiornato sulle offerte riservate ai nostri clienti.'}
          </div>
          <div className="email-input">
            <input
              type="email"
              className="form-control"
              placeholder="Inserisci la tua Email"
              value={email}
              onChange={this.handleChangeEmail}
            />
            <Button
              type="submit"
              className="btn btn-primary btn-thick"
              disabled={!this.state.email || !this.state.privacy}
            >
              {!!loading && <FaSpinner className="pulse" />}
              Ricevi offerte
            </Button>
          </div>
          <CheckboxContainer className="privacy">
            <input
              className="form-control"
              type="checkbox"
              id="privacy"
              name="privacy"
              checked={this.state.privacy}
              onChange={this.handleChangePrivacy}
            />
            <label htmlFor="privacy">
              Accetto il trattamento dei dati sulla{' '}
              <Link
                aria-label="Leggi la nostra Informativa sulla Privacy"
                to="/pagine/informativa-privacy"
                target="_blank"
                style={{ fontWeight: 'bold' }}
              >
                privacy
              </Link>
            </label>
          </CheckboxContainer>
        </form>
        {!!error && (
          <div className="alert alert-danger">
            È avvenuto un errore durante il salvataggio. Riprova più tardi.
          </div>
        )}
        {!!iscritto && (
          <div className="alert alert-success">
            Iscrizione avvenuta correttamente. Grazie!
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    loading: state.newsletter.loading,
    iscritto: state.newsletter.iscritto,
    error: state.newsletter.error,
    uiVariantInputText: state.store.data.uiVariants.inputText,
    hasIubendaCookieSolution:
      state.store.data.features.hasIubendaCookieSolution,
    iubendaApiKey: state.store.data.integrazioni.iubenda.apiKey,
  };
}

export default connect(mapStateToProps, { saveNewsletter })(Newsletter);
